import { useEffect, useState, useContext } from "react"; 
import { ChatContext } from "../context/ChatContext"; 
import AsyncLocalStorage from '@createnextapp/async-local-storage'; 
import { HomeIcon } from "@heroicons/react/24/outline";
import FeedChatButton from "./FeedChatButton";
import socket from "../services/socket";

const SideChatFeed = ({ searchText }) => {
  const { data, dispatch } = useContext(ChatContext); 
  const [chats, setChats] = useState(data.lastMessages);
  const [currentChat, setCurrentChat] = useState(data.currentChat);
 const [allChats, setAllChats] = useState(data.lastMessages); // full list
 

useEffect(() => {

  // Sort messages: unread first, then by timestamp
  const sortedMessages = [...(data.lastMessages || [])].sort((a, b) => {
    // Prioritize unread messages (assuming direction 0 is incoming)
    const unreadA = a.unread > 0 && a.direction === 0;
    const unreadB = b.unread > 0 && b.direction === 0;

    if (unreadA && !unreadB) return -1; // a comes first
    if (!unreadA && unreadB) return 1;  // b comes first

    // If both are unread or both are read, sort by timestamp (most recent first)
    return b.timestamp - a.timestamp;
  });
  
  setAllChats(sortedMessages);
  setCurrentChat(data.currentChat);

  // Apply search filter if provided
  if (!searchText || String(searchText).trim() === '') {
    setChats(sortedMessages);
  } else {
    const lower = String(searchText).toLowerCase();
    const filtered = sortedMessages.filter(chat => 
      (chat.customer_name || '').toLowerCase().includes(lower) ||
      (chat.name || '').toLowerCase().includes(lower) ||
      (chat.channel_id || '').toLowerCase().includes(lower) ||
      (chat.userId || '').toString().toLowerCase().includes(lower)
    );
    setChats(filtered);
  }
}, [data.lastMessages, data.currentChat, searchText]);
 
  const HandleSelect = async (chat) => {    
    let client_id = await AsyncLocalStorage.getItem("silu-ClientId");
    if (client_id) { 
      socket.emit("set-channel", {clientId: client_id, channelId: chat.channel_id} );
    }   
    
    // For WhatsApp chats (category 2), the channel_id is the phone number
    // Look up the account by phone number to get accurate account details
    let accountNo = chat.account_no;
    let customerName = chat.name;
    
    if (chat.category === 2 && chat.channel_id) {
      try {
        // Import the authenticateAccount function
        const edamsApi = await import("../../../../models/edamsModel");
        
        // Use the phone number (channel_id) to look up the account
        const phoneNumber = chat.channel_id.replace(/\D/g, ''); // Remove non-digits
        const accountLookup = await edamsApi.authenticateAccount(phoneNumber);
        
        if (accountLookup && accountLookup.status === 1 && accountLookup.accounts && accountLookup.accounts.length > 0) {
          // Use the first account if multiple are found
          const primaryAccount = accountLookup.accounts[0];
          accountNo = primaryAccount.CUSTKEY;
          customerName = primaryAccount.NAME || chat.name;
          
          console.log(`📱 WhatsApp chat: Looked up account by phone ${phoneNumber}:`, {
            accountNo,
            customerName,
            totalAccounts: accountLookup.accounts.length
          });
        } else {
          console.log(`📱 WhatsApp chat: No account found for phone ${phoneNumber}, using chat data`);
        }
      } catch (error) {
        console.error('Error looking up account by phone:', error);
        // Fall back to the account_no from the chat object
      }
    }
    
    // Create a proper chat object for the context with the looked-up data
    const chatObject = {
      channel_id: chat.channel_id,
      customer_name: chat.customer_name || customerName, // Use customer_name from backend
      category: chat.category || 1,
      account_no: chat.customer_account || accountNo, // Use customer_account from backend
      unread_count: chat.unread || 0,
      phone_number: chat.category === 2 ? chat.channel_id : null // Store phone for WhatsApp
    };
    
    dispatch({ type: "CHANGE_CHAT", payload: chat.channel_id });
    dispatch({ type: "SET_CATEGORY", payload: chat.category || 1 });
    dispatch({ type: "SET_CHAT", payload: chatObject });
    dispatch({ type: "SET_CUSTOMER", payload: customerName }); // Update customer name in context
    setCurrentChat(chatObject);
    // Then reset the view, which will use the new accountNo to decide on loading
    dispatch({ type: "RESET_ACCOUNT_VIEW" }); 
  }; 

 
 return (
    <div className="flex flex-col h-full max-h-full bg-gray-50">  
          <div className="flex-1 overflow-y-auto min-h-0">
            {Array.isArray(chats) && chats.length > 0 ? (
              <div className="p-3 space-y-2">  
                {chats.map((chat) => (
                  <FeedChatButton
                    key={chat.channel_id || chat.chat_id}
                    message={chat}
                    currentChat={currentChat}
                    handleSelect={HandleSelect}
                  />
                ))}
              </div>
            ) : (
              <div className="flex-1 flex items-center justify-center p-8">
                <div className="text-center text-gray-500">
                  <HomeIcon className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                  <p className="text-lg font-medium">No chats found</p>
                  <p className="text-sm">Start a conversation to see it here</p>
                </div>
              </div>
            )}
          </div>
        </div>
 )
};

export default SideChatFeed;
